module.exports = __webpack_public_path__ + "static/media/build_course.50df5049.svg";